import Header from "@components/Header/Header"
import { useNavigate } from "react-router"
import { Container, Content, KYCContainer } from "./Account.styles"
import KYCLevelCard from "@components/KYCLevelCard/KYCLevelCard"
import KYCAccountProfileCard from "@components/KYCAccountProfileCard/KYCProfileCard"
import { useTranslation } from "react-i18next"
import usePublicAddress from "@hooks/usePublicAddress"
import useKYCDetail from "@hooks/useKYCDetail"
import LoadingModal from "@components/LoadingModal/LoadingModal"
import useKYCBenefit from "@hooks/useKYCBenefit"

const Account = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const publicAddress = usePublicAddress()
    const { data: userDetails, isLoading: isUserDetailsLoading, levelNumber } = useKYCDetail()
    const { data: kycBenefits, isLoading: isKYCBenefitsLoading } = useKYCBenefit()
    return (
        <Container>
            <Header title={t('page.account.header')} showBackButton onBackClick={() => navigate('/settings')} />
            <Content>
                <KYCContainer>
                    <KYCAccountProfileCard 
                        name={userDetails?.full_legal_name}
                        address={publicAddress} 
                    />
                    <KYCLevelCard 
                        level={levelNumber} 
                        benefits={kycBenefits?.[levelNumber]?.benefits || []} 
                        onUpgrade={kycBenefits?.[levelNumber + 1]?.isActive ? () => navigate('/account-upgrade') : undefined} 
                        disabled={false} 
                    />
                </KYCContainer>
            </Content>
            <LoadingModal visible={isUserDetailsLoading || isKYCBenefitsLoading} />
        </Container>
    )
}

export default Account